// UI strings for the listening cards of inflected forms (card type 'listen', itemId "<lemmaId>#<slot>";
// listencards/formLabel.ts, ListenFace.tsx, WeekListenCards.tsx, formvoices/FormTakeApproval.tsx):
// the answer's line that says which form you heard ("käsky sinulle", "genetiivi yksikössä"), the
// prompt, the week's Kuuntele step and the inflection table's "Kelpaa" row. Finnish (default) and
// English side by side; en has the same shape. Style: docs/FINNISH-STYLE.md (its grammar terms).
import { defineArea } from '../area';

const n = (k: number, one: string, many: string) => `${k} ${k === 1 ? one : many}`;

export const listenFormsFi = {
  prompt: 'Mitä muoto tarkoittaa?',
  /** Before the form line on the answer: "Muoto: käsky sinulle". */
  formLine: (form: string) => `Muoto: ${form}`,
  /** A case form's number, in the inessive: "genetiivi yksikössä". */
  numberIn: { sg: 'yksikössä', pl: 'monikossa', pc: 'muutamassa', col: 'kollektiivissa', pcpl: 'muutaman monikossa', colpl: 'kollektiivin monikossa' },
  /** Cells with the same form: "vokatiivi yksikössä tai monikossa", "genetiivi, datiivi tai lokatiivi monikossa". */
  or: (items: readonly string[]) => (items.length < 2 ? (items[0] ?? '') : `${items.slice(0, -1).join(', ')} tai ${items[items.length - 1]}`),
  /** A command to the one or the many you speak to (lesson 21, "Käsky sinulle ja teille"). */
  command: { sg: 'käsky sinulle', pl: 'käsky teille' },
  negative: 'kielteinen',
  /** The week's Kuuntele step. */
  week: {
    formsWaiting: (k: number) =>
      `${n(k, 'muoto', 'muotoa')} saa kuuntelukortin, kun tunnet ${k === 1 ? 'sanan ja olet käynyt muodon oppitunnin' : 'sanat ja olet käynyt muotojen oppitunnit'}.`,
  },
  /** The inflection table's form panel: may this take voice a listening card of the form? */
  approval: {
    head: 'Muodon kuuntelukortin äänenä',
  },
};

export const listenFormsEn: typeof listenFormsFi = {
  prompt: 'What does the form mean?',
  formLine: (form) => `Form: ${form}`,
  numberIn: { sg: 'singular', pl: 'plural', pc: 'paucal', col: 'collective', pcpl: 'paucal plural', colpl: 'collective plural' },
  or: (items) => (items.length < 2 ? (items[0] ?? '') : `${items.slice(0, -1).join(', ')} or ${items[items.length - 1]}`),
  command: { sg: 'command to one', pl: 'command to several' },
  negative: 'negative',
  week: {
    formsWaiting: (k) =>
      `${k} ${k === 1 ? 'form becomes a listening card once you know the word and have done the form’s lesson' : 'forms become listening cards once you know the words and have done the forms’ lessons'}.`,
  },
  approval: {
    head: 'As the form’s listening card voice',
  },
};

// Messages.listenForms (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('listenForms', listenFormsFi, listenFormsEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof listenFormsFi> {}
}
